// extracted by mini-css-extract-plugin
export var aiStarIcon = "_8n-4";
export var closeButton = "_8n-6";
export var dismissButton = "_8n-3";
export var editImageWithAiContainer = "_8n-8";
export var imageUploadWrapper = "_8n-7";
export var misspelledWord = "_8n-5";
export var spellCheckContainer = "_8n-2";
export var spin = "_8n-1";
export var spinning = "_8n-0";